var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_9936)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 2.1875V3.5C13 4.70859 10.0895 5.6875 6.5 5.6875C2.91049 5.6875 0 4.70859 0 3.5V2.1875C0 0.978906 2.91049 0 6.5 0C10.0895 0 13 0.978906 13 2.1875ZM11.4098 5.8707C12.0134 5.66836 12.5676 5.40859 13 5.08867V7.875C13 9.08359 10.0895 10.0625 6.5 10.0625C2.91049 10.0625 0 9.08359 0 7.875V5.08867C0.432366 5.41133 0.986607 5.66836 1.59018 5.8707C2.89308 6.3082 4.62835 6.5625 6.5 6.5625C8.37165 6.5625 10.1069 6.3082 11.4098 5.8707ZM0 9.46367C0.432366 9.78633 0.986607 10.0434 1.59018 10.2457C2.89308 10.6832 4.62835 10.9375 6.5 10.9375C8.37165 10.9375 10.1069 10.6832 11.4098 10.2457C12.0134 10.0434 12.5676 9.78359 13 9.46367V11.8125C13 13.0211 10.0895 14 6.5 14C2.91049 14 0 13.0211 0 11.8125V9.46367Z",
    fill: "#43BBC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_9936"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.c1b64dc6abfe87b60159abc5a14bd825.svg";
export { ForwardRef as ReactComponent };